export default __webpack_public_path__ + "static/media/06-EXT-(3-6).a02064ee.jpg";